import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5da1125d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "sales-list-header",
  class: "row g-4 py-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "sales-list-header-title",
  class: "col-3 d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("h6", { style: {"color":"var(--cor_texto_1)"} }, "Relatório de Produtos")
], -1))
const _hoisted_3 = {
  id: "sales-list-header-search",
  class: "col-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  style: {"color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_5 = { class: "col-3 d-flex align-items-center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"87\" viewBox=\"0 0 60 87\" fill=\"var(--cor_btn_2)\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5da1125d><g data-v-5da1125d><g data-v-5da1125d><path d=\"M34 78.9011C32.8954 78.9011 32 77.6699 32 76.1511C32 74.6323 32.8954 73.4011 34 73.4011H55.9999C58.2091 73.4011 59.9999 75.8635 59.9999 78.9011H34Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M34 67.9011C32.8954 67.9011 32 66.6699 32 65.1511C32 63.6324 32.8954 62.4011 34 62.4011H57.9999C59.1045 62.4011 59.9999 63.6324 59.9999 65.1511C59.9999 66.6699 59.1045 67.9011 57.9999 67.9011H34Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M34 56.9012C32.8954 56.9012 32 55.67 32 54.1512C32 52.6324 32.8954 51.4012 34 51.4012H57.9999C59.1045 51.4012 59.9999 52.6324 59.9999 54.1512C59.9999 55.67 59.1045 56.9012 57.9999 56.9012H34Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M34 45.9012C32.8954 45.9012 32 44.67 32 43.1512C32 41.6324 32.8954 40.4012 34 40.4012H57.9999C59.1045 40.4012 59.9999 41.6324 59.9999 43.1512C59.9999 44.67 59.1045 45.9012 57.9999 45.9012H34Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M34 34.9012C32.8954 34.9012 32 33.67 32 32.1512C32 30.6325 32.8954 29.4012 34 29.4012H57.9999C59.1045 29.4012 59.9999 30.6325 59.9999 32.1512C59.9999 33.67 59.1045 34.9012 57.9999 34.9012H34Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M34 23.9013C32.8954 23.9013 32 22.67 32 21.1513C32 19.6325 32.8954 18.4013 34 18.4013H57.9999C59.1045 18.4013 59.9999 19.6325 59.9999 21.1513C59.9999 22.67 59.1045 23.9013 57.9999 23.9013H34Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M34 12.9013C32.8954 12.9013 32 11.6701 32 10.1513C32 8.63252 32.8954 7.40131 34 7.40131H59.9999C59.9999 10.4389 58.2091 12.9013 55.9999 12.9013L34 12.9013Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M40 10.1513C40 8.63252 40.8954 7.40131 42 7.40131C43.1045 7.40131 44 8.63252 44 10.1513V76.1511C44 77.6699 43.1045 78.9011 42 78.9011C40.8954 78.9011 40 77.6699 40 76.1511V10.1513Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path><path d=\"M55.9999 12.9013C55.9999 9.86373 57.7908 7.40131 59.9999 7.40131V78.9011C57.7908 78.9011 55.9999 76.4387 55.9999 73.4011V12.9013Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.31949 12.4237L35.3194 0.121115C36.6232 -0.350673 37.9999 0.615196 37.9999 2.00178V84.6701C37.9999 85.9456 36.822 86.8952 35.5756 86.6246L1.57567 79.2431C0.65604 79.0434 0 78.2296 0 77.2886V14.3044C0 13.4622 0.527567 12.7103 1.31949 12.4237ZM23.6336 49.4653L19.6536 55.151L23.6336 60.8368C24.122 61.5351 24.122 62.6664 23.6336 63.3641L22.7491 64.6277C22.2607 65.3254 21.4684 65.3254 20.98 64.6277L17 58.9419L13.0199 64.6277C12.5315 65.3254 11.7392 65.3254 11.2508 64.6277L10.3663 63.3641C9.87787 62.6658 9.87787 61.5345 10.3663 60.8368L14.3463 55.151L10.3663 49.4653C9.87787 48.767 9.87787 47.6357 10.3663 46.938L11.2508 45.6744C11.7396 44.9766 12.5315 44.9766 13.0199 45.6744L17 51.3601L20.98 45.6744C21.4688 44.9766 22.2607 44.9766 22.7491 45.6744L23.6336 46.938C24.122 47.6363 24.122 48.7675 23.6336 49.4653Z\" fill=\"var(--cor_btn_2)\" data-v-5da1125d></path></g></svg>", 1)
const _hoisted_8 = {
  id: "box-table-remittance",
  class: "row g-4 pt-1 px-2 pb-4",
  style: {"background-color":"white","margin":"10px 0","position":"relative","border-radius":".4rem"}
}
const _hoisted_9 = { class: "col-md-6 col-lg-4" }
const _hoisted_10 = { class: "col-md-6 col-lg-4" }
const _hoisted_11 = { class: "col-md-6 col-lg-4" }
const _hoisted_12 = { class: "col-lg-4 d-flex align-items-center justify-content-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-filter",
  "aria-hidden": "true",
  style: {"font-size":"1.2rem","color":"white"}
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Filtrar", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  id: "box-table-remittance",
  class: "background_1 card"
}
const _hoisted_18 = { style: {"white-space":"nowrap"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { opacity: "0.2" }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M86.1328 20.5078L67.0117 1.36719C66.1328 0.488281 64.9414 0 63.6914 0H62.5V25H87.5V23.8086C87.5 22.5781 87.0117 21.3867 86.1328 20.5078ZM56.25 26.5625V0H17.1875C14.5898 0 12.5 2.08984 12.5 4.6875V95.3125C12.5 97.9102 14.5898 100 17.1875 100H82.8125C85.4102 100 87.5 97.9102 87.5 95.3125V31.25H60.9375C58.3594 31.25 56.25 29.1406 56.25 26.5625ZM25 14.0625C25 13.1992 25.6992 12.5 26.5625 12.5H42.1875C43.0508 12.5 43.75 13.1992 43.75 14.0625V17.1875C43.75 18.0508 43.0508 18.75 42.1875 18.75H26.5625C25.6992 18.75 25 18.0508 25 17.1875V14.0625ZM25 29.6875V26.5625C25 25.6992 25.6992 25 26.5625 25H42.1875C43.0508 25 43.75 25.6992 43.75 26.5625V29.6875C43.75 30.5508 43.0508 31.25 42.1875 31.25H26.5625C25.6992 31.25 25 30.5508 25 29.6875ZM53.125 81.2266V85.9375C53.125 86.8008 52.4258 87.5 51.5625 87.5H48.4375C47.5742 87.5 46.875 86.8008 46.875 85.9375V81.1934C44.6699 81.0801 42.5254 80.3105 40.748 78.9766C39.9863 78.4043 39.9473 77.2637 40.6367 76.6055L42.9316 74.416C43.4727 73.9004 44.2773 73.877 44.9102 74.2734C45.666 74.7461 46.5234 75 47.4141 75H52.9043C54.1738 75 55.209 73.8438 55.209 72.4238C55.209 71.2617 54.5039 70.2383 53.4961 69.9375L44.707 67.3008C41.0762 66.2109 38.5391 62.7266 38.5391 58.8262C38.5391 54.0371 42.2598 50.1465 46.873 50.0234V45.3125C46.873 44.4492 47.5723 43.75 48.4355 43.75H51.5605C52.4238 43.75 53.123 44.4492 53.123 45.3125V50.0566C55.3281 50.1699 57.4727 50.9375 59.25 52.2734C60.0117 52.8457 60.0508 53.9863 59.3613 54.6445L57.0664 56.834C56.5254 57.3496 55.7207 57.373 55.0879 56.9766C54.332 56.502 53.4746 56.25 52.584 56.25H47.0938C45.8242 56.25 44.7891 57.4062 44.7891 58.8262C44.7891 59.9883 45.4941 61.0117 46.502 61.3125L55.291 63.9492C58.9219 65.0391 61.459 68.5234 61.459 72.4238C61.459 77.2148 57.7383 81.1035 53.125 81.2266Z",
      fill: "#203972"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M86.1328 20.5078L67.0117 1.36719C66.1328 0.488281 64.9414 0 63.6914 0H62.5V25H87.5V23.8086C87.5 22.5781 87.0117 21.3867 86.1328 20.5078ZM25 14.0625C25 13.1992 25.6992 12.5 26.5625 12.5H42.1875C43.0508 12.5 43.75 13.1992 43.75 14.0625V17.1875C43.75 18.0508 43.0508 18.75 42.1875 18.75H26.5625C25.6992 18.75 25 18.0508 25 17.1875V14.0625ZM25 29.6875V26.5625C25 25.6992 25.6992 25 26.5625 25H42.1875C43.0508 25 43.75 25.6992 43.75 26.5625V29.6875C43.75 30.5508 43.0508 31.25 42.1875 31.25H26.5625C25.6992 31.25 25 30.5508 25 29.6875ZM53.125 81.2266V85.9375C53.125 86.8008 52.4258 87.5 51.5625 87.5H48.4375C47.5742 87.5 46.875 86.8008 46.875 85.9375V81.1934C44.6699 81.0801 42.5254 80.3105 40.748 78.9766C39.9863 78.4043 39.9473 77.2637 40.6367 76.6055L42.9316 74.416C43.4727 73.9004 44.2773 73.877 44.9102 74.2734C45.666 74.7461 46.5234 75 47.4141 75H52.9043C54.1738 75 55.209 73.8438 55.209 72.4238C55.209 71.2617 54.5039 70.2383 53.4961 69.9375L44.707 67.3008C41.0762 66.2109 38.5391 62.7266 38.5391 58.8262C38.5391 54.0371 42.2598 50.1465 46.873 50.0234V45.3125C46.873 44.4492 47.5723 43.75 48.4355 43.75H51.5605C52.4238 43.75 53.1231 44.4492 53.1231 45.3125V50.0566C55.3281 50.1699 57.4727 50.9375 59.25 52.2734C60.0117 52.8457 60.0508 53.9863 59.3613 54.6445L57.0664 56.834C56.5254 57.3496 55.7207 57.373 55.0879 56.9766C54.332 56.502 53.4746 56.25 52.584 56.25H47.0938C45.8242 56.25 44.7891 57.4062 44.7891 58.8262C44.7891 59.9883 45.4941 61.0117 46.502 61.3125L55.291 63.9492C58.9219 65.0391 61.459 68.5234 61.459 72.4238C61.459 77.2148 57.7383 81.1035 53.125 81.2266Z",
      fill: "#203972"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_CampEmptyListFeedbackV2 = _resolveComponent("CampEmptyListFeedbackV2")!
  const _component_CampFooterPaginationControl = _resolveComponent("CampFooterPaginationControl")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.keywordSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywordSearch) = $event)),
          placeholder: "Busque por alguma solicitação",
          type: "text",
          disabled: _ctx.isLoading
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.generateExcel())),
          class: "btn btn_background_1 w-100 d-flex align-items-center justify-content-center",
          style: {"gap":"0.8rem","overflow":"hidden","height":"32px"},
          disabled: _ctx.isLoading
        }, [
          _hoisted_7,
          _createTextVNode(" Baixar Planilha ")
        ], 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.company,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company) = $event)),
          multiple: "",
          filterable: "",
          "collapse-tags": "",
          placeholder: "Selecione a companhia",
          clearable: "",
          class: "w-100",
          disabled: _ctx.isLoading
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (el) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: el.id,
                value: el.id,
                label: el.fantasy_name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(el.fantasy_name), 1)
                ]),
                _: 2
              }, 1032, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.store,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.store) = $event)),
          multiple: "",
          filterable: "",
          "collapse-tags": "",
          placeholder: "Selecione a loja",
          clearable: "",
          class: "w-100",
          disabled: _ctx.isLoading
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (el) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: el.id,
                value: el.id,
                label: el.fantasy_name + ' - ' + el.cnpj
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(el.fantasy_name + ' - ' + el.cnpj), 1)
                ]),
                _: 2
              }, 1032, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.sku,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sku) = $event)),
          placeholder: "Digite o SKU",
          type: "text",
          disabled: _ctx.isLoading
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleGetSaleList())),
          class: "btn btn-sm w-100 h-100 background_btn_1",
          style: {"color":"white"}
        }, _hoisted_15)
      ])
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_ctx.saleListRender?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_CampTable, { class: "mb-0 mt-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_18, [
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Companhia")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("SKU")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Codigo interno")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Produto")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Pontuação")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Valor Unidade")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, {
                          class: "py-4 text-center",
                          style: {"width":"12rem"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Unidade de Medida")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Loja")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleListRender, (sale) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: sale.id
                        }, [
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sale.company), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sale.sku), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sale.internal_code), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sale.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sale.points_default), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(Number(sale.points) ? _ctx.formatCurrency(sale.points) : "-"), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString((sale.measure)? (sale.measure) : "-"), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sale.fantasy_name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(_component_CampEmptyListFeedbackV2, {
                key: 1,
                id: "sale-icon-empty-list-feedback"
              }, {
                icon: _withCtx(() => [
                  _hoisted_19
                ]),
                message: _withCtx(() => [
                  _createTextVNode(" Sem Produtos no momento! ")
                ]),
                _: 1
              })),
          (Array.isArray(_ctx.saleListRender) && _ctx.saleListRender.length > 0)
            ? (_openBlock(), _createBlock(_component_CampFooterPaginationControl, {
                key: 2,
                class: "mt-5 mb-20",
                index: _ctx.pageID,
                total: _ctx.pageTotal,
                "onGet:UpdatedPageID": _cache[6] || (_cache[6] = (ID) => _ctx.handlePaginationRendering(ID))
              }, null, 8, ["index", "total"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5
        }))
      : _createCommentVNode("", true)
  ]))
}